// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2y984","col":"styles_col__1H7_1"};